import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const PUT_ROUTE_STATUS_START_RESET = 'PUT_ROUTE_STATUS_START_RESET';
export const PUT_ROUTE_STATUS_START_LOADING = 'PUT_ROUTE_STATUS_START_LOADING';
export const PUT_ROUTE_STATUS_START_SUCCESS = 'PUT_ROUTE_STATUS_START_SUCCESS';
export const PUT_ROUTE_STATUS_START_REJECT = 'PUT_ROUTE_STATUS_START_REJECT';

//* ACTIONS ------------------------------------------------
export const putRouteStatusStartReset = () => ({ type: PUT_ROUTE_STATUS_START_RESET });
export const putRouteStatusStartLoading = () => ({ type: PUT_ROUTE_STATUS_START_LOADING });
export const putRouteStatusStartSuccess = (payload) => ({ type: PUT_ROUTE_STATUS_START_SUCCESS, payload });
export const putRouteStatusStartReject = (payload) => ({ type: PUT_ROUTE_STATUS_START_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const putRouteStatusStartRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.PUT,
        params: { IdRoute: data.idRoute },
    }, getState);
    return request(`/Route/web/UpdateRouteChangestatusStartRoute`, options);
};
